import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-4",
  "use": "menu-4-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"menu-4\"><title>menu-4</title><path d=\"M3.64.91A1 1 0 0 0 2.73 0a1 1 0 0 0-.91.91v3.64H0V10h5.45V4.55H3.63V.91zm3.63 12.73a2.65 2.65 0 0 0 1.82 2.54V20h1.82v-3.82a2.65 2.65 0 0 0 1.82-2.54v-1.82H7.27zm-7.27 0a2.65 2.65 0 0 0 1.82 2.54V20h1.82v-3.82a2.65 2.65 0 0 0 1.82-2.54v-1.82H0zm14.54 0a2.65 2.65 0 0 0 1.82 2.54V20h1.82v-3.82A2.65 2.65 0 0 0 20 13.64v-1.82h-5.46zm3.64-9.09V.91a.91.91 0 1 0-1.82 0v3.64h-1.82V10H20V4.55zM10.91.91A1 1 0 0 0 10 0a1 1 0 0 0-.91.91v3.64H7.27V10h5.45V4.55h-1.81zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-4.svg
// module id = 4DPq
// module chunks = 6